module.exports = __webpack_public_path__ + "img/Coupé.385ff26d.jpg";